import * as firebase from "firebase/app";

import "firebase/analytics";
import "firebase/auth";
import "firebase/firestore";
//import 'firebase/messaging'
import Utils from '@/scripts/Utils';
import { firebaseConfigHomolog, firebaseConfigProd } from '@/utils/firebaseConfig';
import "firebase/functions";
import "firebase/storage";
var { DateTime } = require("luxon");

const homologHost = process.env.VUE_APP_FIREBASE_HOMOLOG_HOST || 'centralfoz-homolog.web.app';
const isHomolog = process.env.NODE_ENV === 'development' || window.location.host === homologHost;

if (isHomolog) {
  console.log("---Develop---");
  var firebaseConfig = firebaseConfigHomolog;
} else {
  var firebaseConfig = firebaseConfigProd;
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

// utils
export const db = firebase.firestore();
if (process.env.NODE_ENV == 'development') {
  // TODO: Get port from environment variable
  firebase.functions().useFunctionsEmulator('http://localhost:5001');
}
export const auth = firebase.auth();
const auth_class = firebase.auth;
//const messaging = firebase.messaging();
export const storage = firebase.storage();

// const storageWaterScan = firebase.app().storage("gs://centralfoz-homolog.appspot.com/water_scan_imgs");


async function updateAlert(newAlertReaded, idAlert) {
  try {
    await db.collection("alerts").doc(idAlert).update({
      average: newAlertReaded.average,
      consumption: newAlertReaded.consumption,
      time: newAlertReaded.time,
      excessive: newAlertReaded.excessive,
      intervalDays: newAlertReaded.intervalDays,
      modem: newAlertReaded.modem,
      threshold: newAlertReaded.threshold,
      usersStatus: newAlertReaded.usersStatus
    });
  } catch (error) {
    console.error(error);
    return 1;
  }
}


async function getAlerts(clientID) {
  var alertsCurrentUser = [];
  try {
    var queryAllAlerts = await db.collection("alerts").orderBy("time", "desc").get();

    queryAllAlerts.docs.forEach((alert) => {

      if (alert.data().usersStatus[clientID]) {

        var newAlert = { ...alert.data(), idAlert: alert.id }
        alertsCurrentUser.push(newAlert);
      }
    });


    return alertsCurrentUser;

  } catch (error) {
    console.error("Erro inesperado ao buscar alerta: ", error)
  }
}

async function addModem(modem) {
  try {
    if (modem["id"] === undefined) {
      throw "field 'id' is missing";
    }
    // Converter ID para lowercase antes de salvar
    const modemData = { ...modem };
    if (modemData.id) {
      modemData.id = modemData.id.toLowerCase();
    }
    await db
      .collection("modens")
      .doc(modemData["id"])
      .set(modemData);
    return 0;
  } catch (error) {
    console.error(error);
    return 1;
  }
}

async function getModem(id) {
  try {
    let doc = await db
      .collection("modens")
      .doc(id)
      .get();
    return doc.data();
  } catch (error) {
    console.error(error);
    return;
  }
}

async function getModems() {
  try {
    var modems = [];
    let doc = await db.collection("modens").get();
    doc.forEach((modem) => {
      modems.push(modem.data());
    });
    return modems;
  } catch (error) {
    console.error(error);
    return;
  }
}

async function updateModem(id, modem) {
  try {
    if (modem["id"] !== id) {
      throw "id cannot be changed./Ids don't match";
    }
    // Converter ID para lowercase antes de salvar
    const modemData = { ...modem };
    if (modemData.id) {
      modemData.id = modemData.id.toLowerCase();
    }
    await db
      .collection("modens")
      .doc(modemData.id)
      .update(modemData);
    return 0;
  } catch (error) {
    console.error(error);
    return 1;
  }
}


async function deleteModem(id) {
  try {
    await db
      .collection("modens")
      .doc(id)
      .delete();
    return 0;
  } catch (error) {
    console.error(error);
    return 1;
  }
}


async function getReadingsFromModem(start, end, mode, modemId) {
  var readings = [];
  // Consumo por dia
  if (mode == "day") { // OK
    try {
      let querySnapshot = await db.collection("daily_readings")
        .where("modem", "==", modemId)
        .where("time", ">=", start)
        .where("time", "<=", end)
        .orderBy("time")
        .get();
      querySnapshot.docs.forEach((doc) => readings.push(doc.data()));
    } catch (error) {
      console.error("Ocorreu um erro inesperado: ", error);
    }
  } else if (mode == "hour") {   // Consumo por hora
    try {
      let querySnapshot = await db.collection("hourly_readings")
        .where("modem", "==", modemId)
        .where("time", ">=", start)
        .where("time", "<=", end)
        .orderBy("time")
        .get();
      querySnapshot.docs.forEach((doc) => readings.push(doc.data()));
    } catch (error) {
      console.error("Ocorreu um erro inesperado: ", error);
    }
  } else if (mode == "month") {  // Consumo por Mês      
    try {
      let querySnapshot = await db.collection("monthly_readings")
        .where("modem", "==", modemId)
        .where("time", ">=", start)
        .where("time", "<=", end)
        .orderBy("time")
        .get();
      querySnapshot.docs.forEach((doc) => readings.push(doc.data()));
    } catch (error) {
      console.error("Ocorreu um erro inesperado: ", error);
    }
  }
  readings = readings.map((item) => ({ ...item, time: Utils.instanceDate(item.time.seconds) }))
  return readings;
}



//registerUser(user, units, sectors): Cria um usuário e adiciona os dados no BD
//user: JSON os os dados do usuário
async function registerUser(user) {
  try {

    await firebase.auth().createUserWithEmailAndPassword(user.email, user.password)
      .then((userCredential) => {
        const uidUser = userCredential.user.uid;
        user.id = uidUser
      })
      .catch((error) => {
        throw new Error(error)
      });
    delete user.password
    delete user.metadata.image
    await db.collection('users').doc(user.id).set(user)
    return user
  } catch (error) {
    return error
  }

}

//updateUserData(uid, name, status, manager, accessRank, dataList): atualiza os dados de um usuário
//uid: String com i do usuário
//Os outros parâmetros são iguais aos da função registerUser
//Os dados que não forem passados (ou passados como undefined) não serão alterados no BD
async function updateUserData(user) {
  try {
    await db
      .collection("users")
      .doc(user.id)
      .update(user);
  } catch (error) {
    console.error(error);
  }
}

async function getUnits() {
  try {
    let ref = db.collection("units").where("deletedAt", "==", null);
    let units = [];
    let querySnapshot = await ref.get();

    let historics = await db.collectionGroup("unit_historics").get()

    let historicsFormatByUnitId = []
    historics.forEach((doc) => {
      historicsFormatByUnitId.push(doc.ref.parent.parent.id)
    });
    querySnapshot.forEach((doc) => {
      const unit_id = doc.id
      const unit_doc = doc

      if (historicsFormatByUnitId.find((id) => id === unit_id)) {
        let accum_historics = []
        historics.forEach((doc) => {
          if (doc.ref.parent.parent.id === unit_id) {
            accum_historics.push(doc.data())
          }
        });
        units.push({ ...unit_doc.data(), historicos: accum_historics });

      } else {
        units.push(
          unit_doc.data());
      }
    });
    return units
  } catch (e) {
    console.error(e)
  }
}

async function getClientByName(name) {
  return new Promise(
    async (resolve, reject) => {
      try {
        let ref = db.collection("users");
        ref = ref.where("name", "==", name);

        let users = [];
        let querySnapshot = await ref.get();
        querySnapshot.forEach((doc) => {
          users.push({
            id: doc.id,
            data: doc.data()
          });
        });
        resolve(users);
      } catch (error) {
        reject(error)
      }
    }
  );
}
async function getClientById(id) {

  try {
    let doc = await db.collection("users")
      .doc(id)
      .get();

    return doc.data()
  } catch (error) {
    console.error(error)
  }

}

async function updateUnit(unit) {
  return new Promise(
    async (resolve, reject) => {
      try {
        await db
          .collection("units")
          .doc(unit.id)
          .update(unit);
        resolve(true);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    }
  );
}


async function getUnitbyId(id) {
  try {
    let doc = await db
      .collection("units")
      .doc(id)
      .get();
    return rankToString(doc.data());
  } catch (error) {
    console.error(error);
    return 1;
  }
}


async function getUserbyId(uid) {
  try {
    let doc = await db
      .collection("users")
      .doc(uid)
      .get();
    return rankToString(doc.data());
  } catch (error) {
    console.error(error);
    return 1;
  }
}

//getUsers(name, manager, accessRank, status): retorna lista com usuários
//Todos os parâmetros são opcionais, os que são forem utilizados devem ser passados como undefined
//name (opcional): String com nome do usuário
//matricula (opcional): String com matricula
//manager (opcional): String com id do gerente (franqueado)
//accessRank (opcional): array de inteiros, representando os níveis de acesso
async function getUsers(name, matricula, manager, accessRank) {
  try {
    if (accessRank !== undefined) {
      let promises = [];
      for (let rank of accessRank) {
        promises.push(getUsers_sr(name, matricula, manager, rank));
      }
      promises = await Promise.all(promises);

      let users = [];
      for (let ele of promises) {
        users = users.concat(ele);
      }
      return users;
    } else {
      return await getUsers_sr(name, matricula, manager, undefined);
    }
  } catch (error) {
    console.error(error);
    return [];
  }
}

async function getUsers_sr(name, matricula, manager, accessRank) {
  try {
    let ref = db.collection("users");

    if (name !== undefined) {
      ref = ref.where("name", ">=", name);
    }
    if (manager !== undefined) {
      ref = ref.where("manager", "==", manager);
    }
    if (accessRank !== undefined) {
      ref = ref.where("rank", "==", accessRank);
    }

    let users = [];
    let querySnapshot = await ref.get();
    querySnapshot.forEach((doc) => {
      if (matricula !== undefined && isIterable(doc.data()["dataList"])) {
        for (let u_data of doc.data()["dataList"]) {
          if (
            u_data["matricula"] !== undefined &&
            u_data["matricula"] == matricula
          ) {
            users.push({ id: doc.id, data: rankToString(doc.data()) });
            break;
          }
        }
      } else {
        users.push({ id: doc.id, data: rankToString(doc.data()) });
      }
    });
    return users;
  } catch (error) {
    console.error(error);
    return [];
  }
}

//deleteUser(uid): deleta usuário
//uid: String com id do usuário
async function deleteUser(data) {
  try {
    // let deletUser = await firebase.auth().updateUser(uid,{disabled: true}) 
    data = Utils.copyObject(data)
    let func = firebase.functions().httpsCallable("deleteUser");
    let ret = await func(data);
    if (ret.data["result"] == 0) {
      return 0;
    } else {
      throw ret.data["error"];
    }
  } catch (error) {
    console.error(error);
    return 1;
  }
}



//getReadings(sector, from, to) retorna uma lista ordenada de JSON contendo medições. Em caso de falha retorna undefined
//sector: String com o identificador do setor.
//
//start (opcional): Um objeto Date.
//Se especificado, retorna as medições feitas a partir do datetime em start, caso contrário, retorna todas as medições.
//
//end (opcional): Um objeto Date.
//Se especificado, retorna as medições feitas até o datetime em end, caso contrário, retorna todas as medições.
//isFoz (opcional): booleano
//Se especificado, retorna medições feitas com a foz (true) ou sem a foz (false)
async function getReadings(sector, start, end, isFoz) {
  let ref = db
    .collection("sectors")
    .doc(sector)
    .collection("readings");
  let data = [];


  if (start !== undefined) {
    ref = ref.where("datetime", ">=", start);
  }
  if (end !== undefined) {
    ref = ref.where("datetime", "<=", end);
  }

  try {
    let querySnapshot = await ref.get();
    if (querySnapshot.empty) {
      return [];
    } else {
      querySnapshot.forEach((doc) => {
        if (isFoz !== undefined) {
          if (
            (isFoz && doc.data()["isFoz"]) ||
            (!isFoz && !doc.data()["isFoz"])
          ) {
            let doc_data = doc.data();
            doc_data["datetime"] = doc_data["datetime"].toDate();
            data.push(doc_data);
          }
        } else {
          let doc_data = doc.data();
          doc_data["datetime"] = doc_data["datetime"].toDate();
          data.push(doc_data);
        }
      });
      data.sort((a, b) => {
        return compareDates(a["datetime"], b["datetime"]);
      });
      return data;
    }
  } catch (error) {
    console.error("Error getting documents:", error);
    return [];
  }
}

async function getReadingsByIdModemAndDateTime(idModem, start, end,limite = 10000) {
  try {
    let readings = []
    const data = await db
      .collection("readings")
      .where("origin", "==", idModem)
      .where("datetime", ">=", start)
      .where("datetime", "<=", end)
      .orderBy("datetime", "asc")
      .get()
    data.forEach((reading) => readings.push(reading.data()))
    return readings
  } catch (error) {
    console.error("Error getReadingsByIdModemAndDateTime" + error)
  }
}


async function readingsByModem(modemId) {

  try {
    var readings = [];
    let doc = await db.collection("readings").where("origin", "==", modemId).orderBy("datetime", "desc").limit(1000).get();

    doc.forEach((reading) => {
      readings.push(reading.data());

    });
    return readings;
  } catch (error) {
    console.error(error);
    return;
  }


  //const asMilPrimeiras = await db.collection("readings").orderBy("datetime", "desc").limit(10).get();

  //return asMilPrimeiras;
}
async function readingsByModemWithLimit(modemId,limit = 10000) {

  try {
    var readings = [];
    let doc = await db.collection("readings")
    .where("origin", "==", modemId)
    .orderBy("datetime", "desc")
    .limit(limit).get();

    doc.forEach((reading) => {
      readings.push(reading.data());

    });
    return readings;
  } catch (error) {
    console.error(error);
    return;
  }


  //const asMilPrimeiras = await db.collection("readings").orderBy("datetime", "desc").limit(10).get();

  //return asMilPrimeiras;
}

//retorna os dados do usuário atual
async function getCurrentUser() {
  if (auth.currentUser !== null) {
    let doc = await db
      .collection("users")
      .doc(auth.currentUser.uid)
      .get();
    return { uid: auth.currentUser.uid, data: doc.data() };
  } else {
    throw Error('firebase.auth().currentUser is null');
  }
}


//helper functions
function compareDates(a, b) {
  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}


// Hydrometers
async function createHydrometer(hydrometer) {
  return new Promise(
    async (resolve, reject) => {
      try {
        // if (!hydrometer['id']) {
        //   return reject("Está faltando o id do hidrômetro");
        // }
        const doc_ref = await db.collection("hydrometers").add(hydrometer);
        hydrometer.id = doc_ref.id;
        await db
          .collection("hydrometers")
          .doc(hydrometer["id"])
          .update({ id: hydrometer.id });
        return resolve(hydrometer);
      } catch (e) {
        reject(e);
      }
    }
  );

  // try {
  //   if (hydrometer["name"] === undefined) {
  //     throw "field 'name' is missing";
  //   }
  //   await db
  //     .collection("hydrometers")
  //     .doc(hydrometer["name"])
  //     .set(hydrometer);
  //   return 0;
  // } catch (error) {
  //   console.error(error);
  //   return 1;
  // }
}

async function getHydrometer(hydrometer) {
  return new Promise(
    async (resolve, reject) => {
      try {
        let response = await db
          .collection("hydrometers")
          .doc(hydrometer.id)
          .get();
        resolve(response.data());
      } catch (e) {
        reject(e);
      }
    }
  );
}

async function getHydrometers() {
  try {
    var hydrometers = [];
    let doc = await db.collection("hydrometers").get();
    doc.forEach((hydrometer) => {
      hydrometers.push(hydrometer.data());
    });
    return hydrometers;
  } catch (error) {
    console.error(error);
    return;
  }
}

async function updateHydrometer(hydrometer) {
  return new Promise(
    async (resolve, reject) => {
      try {
        let response = await db
          .collection("hydrometers")
          .doc(hydrometer.id)
          .update(hydrometer);
        resolve(response);
      } catch (e) {
        reject(e);
      }
    }
  );
}

async function deleteHydrometer(hydrometer) {
  return new Promise(
    async (resolve, reject) => {
      try {
        let response = await db
          .collection("hydrometers")
          .doc(hydrometer.id)
          .delete();
        resolve(response);
      } catch (e) {
        reject(e);
      }
    }
  );
}

// Hydrometers
async function createCalls(called) {
  return new Promise(
    async (resolve, reject) => {
      try {
        const doc_ref = await db.collection("calls").add(called);
        called.id = doc_ref.id;
        await db
          .collection("calls")
          .doc(called["id"])
          .update({ idDoc: called.id });
        return resolve(called);
      } catch (e) {
        reject(e);
      }
    }
  );
}
async function updateCalls(idDoc, called) {
  return new Promise(
    async (resolve, reject) => {
      try {
        await db
          .collection("calls")
          .doc(idDoc)
          .update(called);
        resolve(true);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    }
  );
}
async function addCommment(comment) {

  try {
    await db.collection("calls_comments").add(comment);

    let ref = db.collection("calls_comments").orderBy("time", "desc").where("id_post", "==", comment.id_post)
    let list = [];
    let querySnapshot = await ref.get();
    querySnapshot.forEach((doc) => {
      list.push(doc.data());
    });
    return list;
  } catch (error) {
    console.error(error);
  }

}
async function getComments(id_post) {

  try {
    let ref = db.collection("calls_comments").orderBy("time", "desc").where("id_post", "==", id_post)
    let list = [];
    let querySnapshot = await ref.get();

    return querySnapshot.size;
  } catch (error) {
    console.error(error);
  }

}
async function paginationComments(id_post, lastDoc) {
  let ref = db.collection("calls_comments").orderBy("time", "desc").where("id_post", "==", id_post).limit(10)
  if (lastDoc) {
    ref = ref.startAfter(lastDoc)
  }
  const refSnap = await ref.get()
  const lastDocSnapshot = refSnap.docs[refSnap.docs.length - 1]
  const list = []
  refSnap.forEach((doc) => {
    list.push(doc.data());
  });
  return { result: list.length, list, lastDocSnapshot }

}
async function deleteCalls(idCall) {
  try {
    await db
      .collection("calls")
      .doc(idCall)
      .delete();
    const batch = db.batch();

    let ref = db.collection("calls_comments").where("id_post", "==", idCall)
    const refSnap = await ref.get()

    refSnap.forEach((doc) => {
      batch.delete(doc.ref)
    });
    await batch.commit()

    return 0;
  } catch (error) {
    console.error(error);
    return 1;
  }
}
async function paginationCalls(lastDoc, where = null) {
  let callsRef = ''
  if (where) {
    callsRef = db.collection('calls').where(where.nameParam, "==", where.param).orderBy("openTime", "desc").limit(10)
  } else {
    callsRef = db.collection('calls').orderBy("openTime", "desc").limit(10)
  }
  if (lastDoc) {
    callsRef = callsRef.startAfter(lastDoc)
  }
  const callsSnap = await callsRef.get()
  const lastDocSnapshot = callsSnap.docs[callsSnap.docs.length - 1]
  const calls = []
  callsSnap.forEach((doc) => {
    calls.push(doc.data());
  });
  return { result: calls.length, calls, lastDocSnapshot }
  //return calls.length
}
async function getCallsWhere(call) {

  try {
    let ref = null
    let calls = []
    let querySnapshot = []

    ref = db.collection("calls").where("connections", "==", { unit_id: call });
    querySnapshot = await ref.get();
    querySnapshot.forEach((doc) => {
      calls.push(doc.data());
    });
    return calls
  } catch (error) {
    console.error(error);
  }

}
async function getCalls(call) {
  return new Promise(
    async (resolve, reject) => {
      try {
        let ref = null
        let calls = []
        let querySnapshot = []
        if (call !== undefined) {
          calls = await db.collection("calls").doc(call).get();
        } else {
          ref = db.collection("calls").orderBy("openTime", "desc");
          querySnapshot = await ref.get();
          querySnapshot.forEach((doc) => {
            calls.push(doc.data());
          });
        }
        resolve(calls);
      } catch (error) {
        reject(error)
      }
    }
  );
}
async function callsSize() {
  return new Promise(
    async (resolve, reject) => {
      try {
        let ref = db.collection("calls").orderBy("identifier_OS", "desc");;
        let querySnapshot = await ref.get();
        let calls = []
        querySnapshot.forEach((doc) => {
          calls.push(doc.data());
        });
        resolve(calls);
      } catch (error) {
        reject(error)
      }
    }
  );
}
async function getCallsBy(where, dataTime = null) {
  return new Promise(
    async (resolve, reject) => {
      try {
        let calls = []
        let ref = db.collection("calls");
        if (dataTime) {

          if (dataTime.length > 1 && dataTime[0] > dataTime[1]) {
            ref = ref.where('openTime', '>=', dataTime[1] + 10800000);
            ref = ref.where('openTime', '<=', dataTime[0] + 86400000 + 10800000);
          } else if (dataTime.length > 1 && dataTime[0] < dataTime[1]) {
            ref = ref.where('openTime', '<=', dataTime[1] + 86400000 + 10800000);
            ref = ref.where('openTime', '>=', dataTime[0] + 10800000);
          } else if (dataTime.length > 1 && dataTime[0] === dataTime[1]) {
            ref = ref.where('openTime', '<=', (dataTime[1] + 86400000 + 10800000));
            ref = ref.where('openTime', '>=', (dataTime[0] + 10800000));
          } else {
            ref = ref.where('openTime', '>', dataTime[0]);
          }
        }
        for (const property in where) {
          ref = ref.where(property, '==', where[property]);
        }
        let querySnapshot = await ref.get();
        querySnapshot.forEach((doc) => {
          calls.push(doc.data());
        });
        resolve(calls);
      } catch (error) {
        reject(error)
      }
    }
  );
}


function isIterable(obj) {
  if (obj == null) {
    return false;
  }
  return typeof obj[Symbol.iterator] === "function";
}

function rankToString(json) {
  switch (json["rank"]) {
    case 0:
      json["rank"] = "Super Admin";
      break;
    case 1:
      json["rank"] = "Admin";
      break;
    case 2:
      json["rank"] = "Franqueado";
      break;
    case 3:
      json["rank"] = "Técnico";
      break;
    case 4:
      json["rank"] = "Cliente";
      break;
    case 5:
      json["rank"] = "Associado";
      break
    default:
      json["rank"] = "N/D";
      break;
  }
  return json;
}

function stringToRank(rank) {
  switch (rank) {
    case "Super Admin":
      rank = 0;
      break;
    case "Admin":
      rank = 1;
      break;
    case "Franqueado":
      rank = 2;
      break;
    case "Técnico":
      rank = 3;
      break;
    case "Cliente":
      rank = 4;
      break;
    case "Associado":
      rank = 5;
      break;
    default:
      rank = 4;
      break;
  }
  return rank;
}

function monthDiff(dateFrom, dateTo) {
  return (
    dateTo.getMonth() -
    dateFrom.getMonth() +
    12 * (dateTo.getFullYear() - dateFrom.getFullYear())
  );
}

function hourDiff(dateFrom, dateTo) {
  return Math.floor((dateTo.getTime() - dateFrom.getTime()) / 3600000);
}

function dayDiff(dateFrom, dateTo) {
  return Math.floor((dateTo.getTime() - dateFrom.getTime()) / 86400000);
}

function createModem(data) {
  // Converter ID para lowercase antes de enviar para a função
  const modemData = { ...data };
  if (modemData.id) {
    modemData.id = modemData.id.toLowerCase();
  }
  const func = firebase.functions().httpsCallable("createModem_NLT_API");
  return func(modemData).then(() => addModem(modemData));
}

// --------------------------------------------------------------------------------

async function addWaterAuthority(water) {
  try {
    if (water["id"] === undefined) {
      throw "field 'id' is missing";
    }
    let companySlug = Utils.createSlug(water['company']);
    water['company'] = companySlug;
    water["id"] = water["id"] ?? `${companySlug}_${water['date']}`;
    let ref = db
      .collection("water_authorities")
      .doc(water["id"])
    await ref.set(water)
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
}

async function deleteWaterAuthority(id) {
  try {
    await db
      .collection("water_authorities")
      .doc(id)
      .delete();
    return 0;
  } catch (error) {
    console.error(error);
    return 1;
  }
}

async function getWaterAuthorities(company = null) {
  try {
    let slugCompany = Utils.createSlug(company)
    var waterAuthorities = [];
    let docs = []
    if (company !== null) {
      docs = await db
        .collection("water_authorities")
        .where('company', '==', slugCompany)
        .where('deletedAt', '==', null)
        .get();
    } else {
      docs = await db
        .collection("water_authorities")
        .where('deletedAt', '==', null)
        .get();
    }
    docs.forEach((water) => {
      waterAuthorities.push(water.data());
    });
    return waterAuthorities;
  } catch (error) {
    console.error(error);
    return [];
  }
}

async function getWaterAuthorityByIDs(newIDsArray) {
  try {
    var waterAuthorities = [];
    let docs = await db
      .collection("water_authorities")
      .where('id', 'in', newIDsArray)
      .get();
    docs.forEach((water) => {
      waterAuthorities.push(water.data());
    });
    return waterAuthorities;
  } catch (error) {
    console.error(error);
    return [];
  }
}

var firestore = firebase.firestore;
// export utils/refs
export default {
  db,
  auth,
  auth_class,
  storage,
  //initFSM,
  // storageWaterScan,
  getReadingsByIdModemAndDateTime,
  updateAlert,
  getReadingsFromModem,
  getReadings,
  getCurrentUser,
  //setNotificationCallback,
  getClientByName,
  getUsers_sr,
  readingsByModemWithLimit,
  registerUser,
  updateUserData,
  getUsers,
  deleteUser,
  getUserbyId,
  stringToRank,
  createCalls,
  getUnitbyId,
  updateUnit,
  addModem,
  getModem,
  getModems,
  getAlerts,
  monthDiff,
  hourDiff,
  dayDiff,
  updateModem,
  deleteModem,
  createHydrometer,
  getHydrometer,
  getHydrometers,
  updateHydrometer,
  deleteHydrometer,
  createModem,
  getUnits,
  getCalls,
  updateCalls,
  getClientById,
  addWaterAuthority,
  deleteWaterAuthority,
  getWaterAuthorities,
  getWaterAuthorityByIDs,
  readingsByModem,
  getCallsBy,
  callsSize,
  paginationCalls,
  getCallsWhere,
  paginationComments,
  deleteCalls,
  addCommment,
  getComments,
};
